<template>
  <span class="excelExport">
    <a-button
      :class="$style.excelButton"
      @click="exportExcel"
      icon="file-excel"
      :loading="loading"
    >
      Excel
      <!-- <a-icon type="file-excel" theme="twoTone" two-tone-color="#52c41a" />-->
    </a-button>
  </span>
</template>

<script>
import XLSX from "xlsx";
//window.$ = window.jQuery = require("jquery");

export default {
  name: "excel-export",
  props: {
    columns: {
      type: Array,
      default: new Array()
    },
    data: {
      type: Array,
      default: new Array()
    },
    filename: {
      type: String,
      default: "excel"
    },
    sheetname: {
      type: String,
      default: "SheetName"
    }
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    async exportExcel() {
      try {
        this.loading = true;
        //this.$emit("exportRequested"); //cannot use emit because it doesn't allow async functions. Instead using $listeners.
        await this.$listeners.exportRequested();

        if (!this.data || this.data.length === 0) throw new Error();

        let createXLSLFormatObj = [];
        let newXlsHeader = [];
        //let vm = this;
        if (this.columns.length === 0) {
          console.log("Add columns!");
          return;
        }
        if (this.data.length === 0) {
          console.log("Add data!");
          return;
        }
        this.columns.forEach(value => {
          //$.each(vm.columns, function(index, value) {
          newXlsHeader.push(value.label);
        });

        // $.each(vm.columns, function(index, value) {
        //   newXlsHeader.push(value.label);
        // });

        createXLSLFormatObj.push(newXlsHeader);
        this.data.forEach(value => {
          //$.each(vm.data, function(index, value) {
          let innerRowData = [];
          this.columns.forEach(val => {
            //$.each(vm.columns, function(idx, val) {
            var innerValue; //needs to be declared as var to enter catch scope;
            const segments = val.field.split(".");
            if (segments.length > 1) {
              //if the json has inner properties/objects such as object.property1 then the it checks how much depth and points to the object value accodingly. The try/catch is for when the value of the inner objects are null so that it doesn't throw an error. It only allows for 4 layers deep, Ex: object.object.object.property
              try {
                if (segments.length == 2) {
                  innerValue = value[segments[0]][segments[1]];
                } else if (segments.length == 3) {
                  innerValue = value[segments[0]][segments[1]][segments[2]];
                } else if (segments.length == 4) {
                  innerValue =
                    value[segments[0]][segments[1]][segments[2]][segments[3]];
                }
              } catch (err) {
                innerValue = null;
              }
            } else {
              innerValue = value[val.field];
            }
            if (val.dataFormat && typeof val.dataFormat === "function") {
              innerRowData.push(val.dataFormat(innerValue));
            } else {
              innerRowData.push(innerValue);
            }
          });
          createXLSLFormatObj.push(innerRowData);
        });

        let filename = this.filename + ".xlsx";

        let ws_name = this.sheetname;

        let wb = XLSX.utils.book_new(),
          ws = XLSX.utils.aoa_to_sheet(createXLSLFormatObj);
        XLSX.utils.book_append_sheet(wb, ws, ws_name);
        XLSX.writeFile(wb, filename);

        this.loading = false;

        this.$notification["success"]({
          message: "Éxito",
          description: "Exportación exitosa."
        });
      } catch (err) {
        this.loading = false;
        this.$notification["warning"]({
          message: "Error",
          description: "Hubo un error al exportar los datos."
        });
        console.log(err);
      }
    }
  }
};
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>

<style lang="css">
.excelExport .ant-btn span {
  margin-left: 4px !important;
}
.excelExport .ant-btn:hover,
.excelExport .ant-btn:focus {
  color: #52c41a;
}
</style>
